import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=6b5407f7&scoped=true&"
import script from "./LoadingIcon.vue?vue&type=script&lang=js&"
export * from "./LoadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=6b5407f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5407f7",
  null
  
)

export default component.exports